import Column from "@components/Grid/Column";

/**
 * component to render in nominations tab at How to Nominate page
 */
const NominationsSection = (): React.ReactElement => {
  return (
    <Column rootClassName="bg-gray-50 py-4 px-5">
      <p>Nominations for SI Awards 2025 are closed.</p>
    </Column>
  );
};

export default NominationsSection;
